export default __webpack_public_path__ + "static/REUPoster-843e665b891fbf92b606651513982964.pdf";